var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('app-list',{attrs:{"title":_vm.$t('pages.speakers.title'),"display":['search', 'details'],"path":"person","alias":"speakers","fetch":_vm.$api.person.getSpeakers,"params":_vm.params}},[_c('program-speaker-modal'),_vm._v(" "),_c('program-session-modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }